import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import masterCard from "../../assets/all-images/phonepe-logo-icon.png";
import paypal from "../../assets/all-images/paytm-icon.png";
import "../../styles/payment-method.css";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import Box from "@mui/material/Box";

import Modal from "@mui/material/Modal";
import axiosInstance from "../../axiosInstance";
import { constants } from "../../Utils/constants";


const PaymentMethod = () => {

  const dispatch = useDispatch();
  const bookingSelector = useSelector((state) => state.booking);
  const userSelector = useSelector((state) => state.user);

  const [paymentmode, setPaymentMode] = useState({ paymentMode: "", upi: "" });
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [inner, setInner] = useState(true);


  const handleBooking = async () => {
    if (paymentmode.upi != "") {
      const id = uuidv4();
        const respBook = await axiosInstance.post(constants.serverUrl+"/booking/add", {
          userId: userSelector.currentUser.id,
          carId: bookingSelector.selectedCar.vehicleNo,
          fromDate: bookingSelector.findCarDetails.selectedDateForTripStart,
          toDate: bookingSelector.findCarDetails.selectedDateForTripEnd,
          tripCost: bookingSelector.finalTripCost,
          branchId: bookingSelector.findCarDetails.branchId,
          
          transId: id,
          paymentMode: paymentmode.paymentMode,
          amount: bookingSelector.finalTripCost
        });

        if (respBook.data.status == true) {
          handleOpen();
          setTimeout(() => {
            setInner(false);
            setTimeout(() => {
              setLoading(false);
              toast.success("Car Booked Successful", { theme: "colored" });
            }, 4000);
          }, 5000);
          setSuccess(true);
          // toast.success("Car Booked Successful", { theme: "colored" });

        } else {
          toast.error(respBook.data.message, { theme: "colored" });
        }
      } else {
        toast.error("Payment upi should not be empty!", { theme: "colored" });
      }
    
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handleChange = (e) => {
    setPaymentMode({ ...paymentmode, [e.target.name]: e.target.value });
  };
  return (
    <>
      <div className="payment mt-3 d-flex align-items-center justify-content-between">
        <label htmlFor="" className="d-flex align-items-center gap-2">
          <input
            type="radio"
            name="paymentMode"
            value="online"
            onChange={handleChange}
          />{" "}
          PhonePe
        </label>
        <img src={masterCard} height={30} width={30}  alt="" />
      </div>

      <div className="payment mt-3 d-flex align-items-center justify-content-between">
        <label htmlFor="" className="d-flex align-items-center gap-2">
          <input
            type="radio"
            name="paymentMode"
            value="online"
            onChange={handleChange}
          />{" "}
          Paytm
        </label>
        <img src={paypal} height={26} width={100} alt="" />
      </div>

      <div class="input-group mt-3 form-control">
        <span class="input-group-text" id="basic-addon1">
          @UPI
        </span>
        <input
          type="text"
          disabled={paymentmode.paymentMode ? false : true}
          class="form-control"
          placeholder="XXXXXX@ybl"
          aria-label="Username"
          name="upi"
          aria-describedby="basic-addon1"
          onChange={handleChange}
        />
      </div>
      <div className="payment text-end mt-5">
        <button data-bs-toggle="modal" onClick={handleBooking}>
          Reserve Now
        </button>
      </div>
      
      {success==true&&(
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        {loading==false?
        <div className="d-flex justify-content-center align-items-center">
            <div>
                <div className="mb-4 text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="text-success" width="75" height="75"
                        fill="green" className="bi bi-check-circle-fill" viewBox="0 0 16 16">
                        <path
                            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>
                </div>
                <div className="text-center">
                    <h1>Thank You !</h1>
                    <p>Car booked successfully!. Details have been sent to your email. <b>Safe travels!</b> </p>
                    <button  onClick={handleClose} className="btn btn-primary">Close</button>
                </div>
            </div>
          </div> 
        :
        <>
          {!inner?
          <>
          <div class="spinner-border text-success" role="status">
          <span>₹₹</span>
          </div>  
           <span><b>Your payment process is almost done...</b></span>
          </> 
          :
          <>
          <div class="spinner-border text-primary" role="status">
          <span>₹₹</span>
          </div> 
          <span>Please do not press back.</span>
          </>
          }
        </>
        } 
        </Box>
      </Modal>

      )}
    </>
  );
};

export default PaymentMethod;
